export const band = (x, bands) => (bands || []).reduce((t, b) => t + Math.max(0, Math.min(x, b.to ?? Infinity) - b.from) * b.rate / 100, 0);

export const taxAud = (t, incomeAud, rate) => {
  if (!t) return null;
  const taxable = Math.max(0, incomeAud / rate - (t.allowance || 0));
  return (band(taxable, t.bands) + taxable * (t.surcharge_pct || 0) / 100) * rate;
};

export const buyCost = (p) => (p ? p.typical_price * p.closing_pct / 100 + p.closing_fixed : null);
export const yearlyCost = (p) => (p ? p.typical_price * p.yearly_pct / 100 + p.yearly_fixed : null);

export const aud = (n) => (n == null ? "—" : `A$${Math.round(n).toLocaleString("en-AU")}`);
export const local = (n, sym) => (n == null ? "—" : `${sym}${Math.round(n).toLocaleString("en-AU")}`);
